/**
 * Created by mark on 6/27/2019.
 */
import Service from "../../../Services/index";
import moment from "moment";

const SpecialCustomer = {
    namespaced: true,
    state: {
        customer_report_table : [],
        special_customer_data : [],
        search : {
            date : [],
            customer_id : "",
            start_date : "",
            end_date : "",
            product_type_id : '',
        },
        dataPaginate:{
            current_page :1,
            from : 1,
            last_page : 1,
            per_page : 1,
            total : 1,
            to : 1
        },
    },
    mutations: {
        GET_CUSTOMER_REPORT_TABLE : (state,res)=>{
            state.customer_report_table = res;
        },
        SHOW_CUSTOMER_SPECIAL_DATA : (state,res)=>{
            state.special_customer_data = res.data;
            state.dataPaginate = {
                current_page :res.current_page,
                from : res.from,
                last_page : res.last_page,
                per_page : res.per_page,
                total : res.total,
                to : res.to
            };
        },
        CLEAR_SEARCH : (state)=>{
            state.search.date = [];
            state.search.start_date = '';
            state.search.end_date = '';
            state.search.product_type_id = '';
        },
        SET_CUSTOMER_ID :(state,customer_id)=>{
            state.search.customer_id = customer_id;
        }
    },
    actions: {
        setCustomerReport({commit},page=1){
            return Service.SpecialCustomer.getReportSpecialCustomer(page).then(response=>{
                commit("GET_CUSTOMER_REPORT_TABLE",response);
            })
        },
        showCustomerSpecial({commit}, {page,data}){
            commit('SET_CUSTOMER_ID',data.customer_id);
            return Service.SpecialCustomer.showSpecialCustomer(page,data).then(data=>{
                commit("SHOW_CUSTOMER_SPECIAL_DATA",data);
            })
        },
        searchSpecialCustomer({commit},data){
            return Service.SpecialCustomer.searchSpecialCustomer(data).then(response=>{
                commit("SHOW_CUSTOMER_SPECIAL_DATA",response);
            })
        },
        clearSearch({commit}){
            commit("CLEAR_SEARCH");
        },
        printSpecialCustomer({commit},data) {
            return Service.SpecialCustomer.printSpecialCustomer(data);
        }
    }
};

export default SpecialCustomer;
